import React,{useState,useEffect} from 'react'
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  useLocation,
} from 'react-router-dom'
import { Userpilot } from 'userpilot'

import axios from 'axios'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import { useIdleTimer } from 'react-idle-timer'
import { WindowReload, WindowURL, WindowLocation, RouteURL, TypeServerOnline, UnliveUpdateFunction } from '../services/redirect'

import Spinner from '../services/spinner'
import AlertMessage from '../services/alert'


/*---------------------------------------
 Include Header
---------------------------------------*/
import PageHeaderComponent from '../components/page-header'


/*---------------------------------------
 404 page
---------------------------------------*/
import ErrorPage from './ErrorPage/error'
import Redirect404 from './ErrorPage/redirect'


/*---------------------------------------
 Pages Default
---------------------------------------*/
import Dashboard from './Dashboard/dashboard'
import UserManagementComponent from './UserManagement/administrator/list'
import ManageRoleComponent from './UserManagement/users-role/list'
import PagesComponent from './SystemAdministration/pages/list'


/*---------------------------------------
 Pages
---------------------------------------*/
import OrdersComponent from './Orders/list_orders'
import DetailsOrderComponent from './Orders/details_order'


import NewCustomerComponent from './Customers/new_customer'
import EditCustomerComponent from './Customers/edit_customer'
import ListCustomerComponent from './Customers/list_customer'
import InviteComponent from './Customers/invite'

import NewProductComponent from './Products/new_product'
import EditProductComponent from './Products/edit_product'
import ListProductComponent from './Products/list_product'

import CreateProcessingNote from './Processing-notes/note_create'
import EditProcessingNote from './Processing-notes/note_edit'
import ProcessingNotesComponent from './Processing-notes/note_list'
import HistoryNotesComponent from './Processing-notes/note_history'
import DeletedProcessingNotesComponent from './Processing-notes/deleted_note_list'
import DeletedHistoryNotesComponent from './Processing-notes/deleted_note_history'



import NewComplianceProductComponent from './Compliance/products/new'
import EditComplianceProductComponent from './Compliance/products/edit'
import ComplianceProductListComponent from './Compliance/products/list'

import NewComplianceCountriesComponent from './Compliance/countries/new'
import EditComplianceCountriesComponent from './Compliance/countries/edit'
import ComplianceCountriesComponent from './Compliance/countries/list'


import NewBannerComponent from './Banners/new'
import EditBannerComponent from './Banners/edit'
import BannersListComponent from './Banners/list'


/*---------------------------------------
 Reports
---------------------------------------*/
import ProccessedOrdersCurrentWeek from './Reports/processed-orders/weekly/current-week'
import ProccessedOrdersCurrentMonth from './Reports/processed-orders/monthly/current-month'
import ProccessedOrdersCustomDate from './Reports/processed-orders/custom-date/custom-date'
import ProccessedOrderStatus from './Reports/processed-orders/status/order-status'
import TotalOrdersReport from './Reports/processed-orders/total-orders-report/total-orders-report'
import ExportOrdersComponent from './Reports/processed-orders/export-orders/indexExportOrders'
import SentEmailLogs from './Reports/email-logs/email-logs'

/*---------------------------------------
 Administration
---------------------------------------*/
import LogsAdministratorComponent from './Administration/logs-administrator/logs-administrator'
import AuditCustomerComponent from './Administration/audit-account/audit-account'
import LogsCustomersComponent from './Administration/logs-customers/logs-customers'
import LockCustomersComponent from './Administration/lock-customer/lock-customer'
import DeletedOrdersComponent from './Administration/deleted-orders/deleted_orders'
import DetailsDeletedOrderComponent from './Administration/deleted-orders/details_deleted_order'
import TermsConditionsComponent from './Administration/terms-and-conditions/list'



import MessageComponent from './Administration/custom-message/message'


Userpilot.initialize('NX-e987cecf');

export default function RootComponent(props){


   /*----------------------------------------
    TIMEZONE DEFAULT
  -----------------------------------------*/
  //momentTimezone.tz.setDefault("Europe/London");


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(true);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }


  /*------------------------------------------------------
    ALERT MESSAGE
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }




  /*------------------------------------------------------
    EXACT REQUEST
  -------------------------------------------------------*/
  const [exactData, setexactData] = useState({});
  function ExactRequest(){

    setcontentspinner({intent:'spinner',settings:{options:'white',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','exact_auth_status');
    axios.post('/admin/exact/__auth.php',formData)
    .then(function (response) {
        let obj = response.data;
          
        setexactData(obj);
  
        setTimeout(function() {
          setspinner(false);
        },1000);
        
    })
    .catch(function (error){
      setspinner(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },2000);
    });
}


  /*------------------------------------------------------
    AUTH USER
  -------------------------------------------------------*/
  const [dataUser, setDataUser] = useState({});
  function AuthUser(){

      setcontentspinner({intent:'spinner',settings:{options:'white',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
      setspinner(true);

      let formData = new FormData();
      formData.append('type','auth');
      axios.post('/auth/request.php',formData)
      .then(function (response) {
          let obj = response.data;

          if(obj==0){
            WindowLocation('/login');
            return false;
          }

          ExactRequest();

          setDataUser({
            ...dataUser,
            id:obj.id,
            date_added:obj.date_added,
            name:obj.name,
            fullname:obj.fullname,
            role_name:obj.role_name,
            email:obj.email,
            phone:obj.phone,
            country:obj.country,
            description:obj.description,
            status:obj.status,
            type_profile:obj.type_profile,
            image:obj.image,
            file_image:obj.file_image,
            file:obj.image,
            file_name:obj.file_name,
            file_url:obj.file_url
          });



          Userpilot.identify(obj.id,{
            name: obj.fullname,
            email: obj.email,
            created_at: obj.date_added,
          });


          setTimeout(function() {
            setspinner(false);
          },1000);
          


      })
      .catch(function (error){
        setspinner(false);
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {
          setnotify(false);
        },2000);
      });
 }


  /*------------------------------------------------------
    IDLE TIMER
  -------------------------------------------------------*/
  function UserAuthBehind(){
    let formData = new FormData();
    formData.append('type','auth');
    axios.post('/auth/request.php',formData)
    .then(function (response) {
        let obj = response.data;
        if(obj==0){
          WindowLocation('/login');
          return false;
        }
    })
    .catch(function (error){
        return false;
    });
  }


  

  /*------------------------------------------------------
    REPORTS SENT AUTOMATICALLY
  -------------------------------------------------------*/
  
  // Weekly reports
  function handleSubmitWeeklyReports(){
    let formData = new FormData();
    formData.append('type','sendMail');
    formData.append('sentby',1);
    axios.post('/admin/reports/send-mail/weekly/request.php',formData)
    .then(function (response) {
      let obj = response.data;
      console.log('Weekly Reports: ' + obj);
    })
    .catch(function (error){
    });
  }

  // Monthly reports
  function handleSubmitMonthlyReports(){
    let formData = new FormData();
    formData.append('type','sendMail');
    formData.append('sentby',1);
    axios.post('/admin/reports/send-mail/monthly/request.php',formData)
    .then(function (response) {
      let obj = response.data;
      console.log('Monthly Reports: ' + obj);
    })
    .catch(function (error){
    });
  }


  

  /*------------------------------------------------------
          Test query
  -------------------------------------------------------*/
  function TestQuery(){
    let formData = new FormData();
    formData.append('type','testquery');
    axios.post('/admin/reports/send-mail/weekly/testrequest.php',formData)
    .then(function (response) {
        let obj = response.data;
        console.log(obj);
    })
    .catch(function (error){
    });
  }

  function SentReportsFunction(){

    let current_time  = moment(new Date(), 'hh').tz('Europe/London').format("hh")
    let day_night     = moment(new Date(), 'a').tz('Europe/London').format("a")
    
    let current_date  = moment(new Date()).tz('Europe/London').format("YYYY-MM-DD")
    let endOfMonth    = moment().endOf('month').tz('Europe/London').format('YYYY-MM-DD')
    
    let dayName       = moment(current_date).format('dddd');


    // Sunday 
    if(dayName=='Sunday'){
      if(day_night=='pm'){
        if(parseInt(current_time)>=8&&parseInt(current_time)<=12){
          handleSubmitWeeklyReports();
          console.log('Generate Sunday PM:__', current_time);
        }
      }
      console.log('Day Name:__', moment(current_date).format('dddd'));
      console.log('Night or Day:__', day_night);
      console.log('Current Time:__', parseInt(current_time));
		}
    

    //console.log(dayName);
    //console.log(day_night);
    //console.log(moment(new Date()).endOf('month').tz('Europe/London').format('YYYY-MM-DD'));

  
    
    // End of the month
    if(endOfMonth==current_date){
      if(day_night=='pm'){
        if(parseInt(current_time)>=8&&parseInt(current_time)<=12){
          handleSubmitMonthlyReports();
          console.log('Generate End of the month PM:__', current_time);
        }
      }
    }


	}

  




  /*------------------------------------------------------
  IDLE TIMER
-------------------------------------------------------*/
  const onPrompt = () => {
    // Fire a Modal Prompt
  }

  const onIdle = () => {
    UserAuthBehind();
    // Close Modal Prompt
    // Do some idle action like log out your user
  }

  const onActive = (event) => {
    // Close Modal Prompt
    // Do some active action
  }

  const onAction = (event) => {
    // Do something when a user triggers a watched event
  }

  const {
    start,
    reset,
    pause,
    resume,
    isIdle,
    isPrompted,
    getRemainingTime,
    getElapsedTime,
    getLastIdleTime,
    getLastActiveTime,
    getTotalIdleTime,
    getTotalActiveTime
  } = useIdleTimer({
    onPrompt,
    onIdle,
    onActive,
    onAction,
    timeout: 1000 * 60 * 5,
    promptTimeout: 0,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange'
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    crossTab: false,
    syncTimers: 0
  })



    useEffect(()=>{

        AuthUser();
        SentReportsFunction();
        setInterval(() => {
          SentReportsFunction();
        }, 1000 * 60 * 5);

        
        /*--------------------------------------------------------------
         User Pilot Integrations
        ---------------------------------------------------------------*/
        Userpilot.reload();
        Userpilot.track("Event Name");
        // e.g. Clicked the purchase button
        Userpilot.track("Clicked purchase button");
        // e.g. Submitted a help ticket
        Userpilot.track("Submitted help ticket", {
          url: "/support",
          article: "installation"
        })

    },[]);

  return (
    <React.Fragment>

        {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}
        {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

        {!spinner&&<PageHeaderComponent data={dataUser} exact={exactData}/>}

        {!spinner&&<div className="app-content-wrapper">
           <div className="appWrapper">

            {TypeServerOnline()==2&&<div class="alert-message error errorhasborder left" style={{'margin':'5px 0 15px 0'}}>
                  <div><i class="info circle icon"></i></div>
                  <div>
                    <h4>TEST SERVER</h4>
                    <p>Right now, you're on the special portal test server.</p>
                  </div>
            </div>}

            <Routes>
               <Route path="/" element={<Dashboard />}/>
               <Route path="/dashboard" element={<Dashboard />}/>

               {/* Pages */}
               <Route path="/orders/list" element={<OrdersComponent />}/>
               <Route path="/orders/details/:id" element={<DetailsOrderComponent />}/>


               <Route path="/customers/new" element={<NewCustomerComponent />}/>
               <Route path="/customers/edit/:id" element={<EditCustomerComponent />}/>
               <Route path="/customers/list" element={<ListCustomerComponent />}/>
               <Route path="/customers/invite" element={<InviteComponent />}/>

               <Route path="/products/new" element={<NewProductComponent />}/>
               <Route path="/products/edit/:id" element={<EditProductComponent />}/>
               <Route path="/products/list" element={<ListProductComponent />}/>


               <Route path="/processing-notes/create" element={<CreateProcessingNote />}/>
               <Route path="/processing-notes/edit/:id" element={<EditProcessingNote />}/>
               <Route path="/processing-notes/history/:id" element={<HistoryNotesComponent />}/>
               <Route path="/processing-notes/list" element={<ProcessingNotesComponent />}/>
               <Route path="/processing-notes/deleted_history/:id" element={<DeletedHistoryNotesComponent />}/>
               <Route path="/processing-notes/deleted_list" element={<DeletedProcessingNotesComponent />}/>

               <Route path="/compliance/product/new" element={<NewComplianceProductComponent />}/>
               <Route path="/compliance/product/edit/:id" element={<EditComplianceProductComponent />}/>
               <Route path="/compliance/product/list" element={<ComplianceProductListComponent />}/>

               <Route path="/compliance/country/new" element={<NewComplianceCountriesComponent />}/>
               <Route path="/compliance/country/edit/:id" element={<EditComplianceCountriesComponent />}/>
               <Route path="/compliance/country/list" element={<ComplianceCountriesComponent />}/>


               <Route path="/banners/new" element={<NewBannerComponent />}/>
               <Route path="/banners/edit/:id" element={<EditBannerComponent />}/>
               <Route path="/banners/list" element={<BannersListComponent />}/>


               {/* User Management */}
               <Route path="/reports/processed-orders/weekly" element={<ProccessedOrdersCurrentWeek />}/>
               <Route path="/reports/processed-orders/monthly" element={<ProccessedOrdersCurrentMonth />}/>
               <Route path="/reports/processed-orders/custom-date" element={<ProccessedOrdersCustomDate />}/>
               <Route path="/reports/processed-orders/status" element={<ProccessedOrderStatus />}/>
               <Route path="/reports/processed-orders/email-logs" element={<SentEmailLogs />}/>
               <Route path="/reports/processed-orders/total-orders-report" element={<TotalOrdersReport />}/>
               <Route path="/reports/export-orders" element={<ExportOrdersComponent />}/>
               
               

               {/* Administration */}
               <Route path="/administration/logs-administrator" element={<LogsAdministratorComponent />}/>
               <Route path="/administration/audit-account" element={<AuditCustomerComponent />}/>
               <Route path="/administration/logs-customer" element={<LogsCustomersComponent />}/>
               <Route path="/administration/account-lock" element={<LockCustomersComponent />}/>

               <Route path="/administration/deleted-orders" element={<DeletedOrdersComponent />}/>
               <Route path="/administration/account-lock" element={<LockCustomersComponent />}/>
               <Route path="/administration/details-deleted-order/:id" element={<DetailsDeletedOrderComponent />}/>

               <Route path="/administration/message" element={<MessageComponent />}/>
               <Route path="/administration/tor-messages" element={<TermsConditionsComponent />}/>

               
  
               {/* User Management */}
               <Route path="/user-management/list" element={<UserManagementComponent />}/>
               <Route path="/user-management/role" element={<ManageRoleComponent />}/>

               {/* System Administration For Developers */}
               <Route path="/system-administration/pages" element={<PagesComponent />}/>

               {/* Page not found: 404 error */}
               <Route path="*" element={<Redirect404 />}/>

      			</Routes>
          </div>
        </div>}


    </React.Fragment>
  )
}
